import { useGetExistingEquipmentFieldTooltipsQuery } from 'features/api/data-api';
import { useMemo } from 'react';

// Admin-managed existing-equipment spec-field info tooltips (AHA-6796):
// fetched once wherever the shared spec-field renderer mounts (RTK Query
// dedupes across simultaneous consumers). Returns a spec-key → content map;
// callers render an info icon only when their key is present, so a missing
// or blank row means no icon rather than an empty tooltip.
export default function useExistingEquipmentFieldTooltips(): Record<
  string,
  string
> {
  const { data } = useGetExistingEquipmentFieldTooltipsQuery();

  return useMemo(() => {
    const contentByCode: Record<string, string> = {};
    (data ?? []).forEach((tooltip) => {
      if (tooltip.content.trim() !== '') {
        contentByCode[tooltip.code] = tooltip.content;
      }
    });
    return contentByCode;
  }, [data]);
}
